import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance (no withCredentials - using token-based auth)
const api = axios.create({
  baseURL: BACKEND_URL,
});

// Add request interceptor to include session token
api.interceptors.request.use(
  (config) => {
    // Get session token from localStorage
    const guestUser = localStorage.getItem('guestUser');
    const user = localStorage.getItem('user');
    
    let sessionToken = null;
    
    if (guestUser) {
      try {
        const parsed = JSON.parse(guestUser);
        sessionToken = parsed.session_token;
      } catch (e) {
        console.error('Failed to parse guestUser:', e);
      }
    }
    
    // If no guest token, check regular user
    if (!sessionToken && user) {
      try {
        const parsed = JSON.parse(user);
        sessionToken = parsed.session_token;
      } catch (e) {
        console.error('Failed to parse user:', e);
      }
    }
    
    // Add Authorization header if we have a token
    if (sessionToken) {
      config.headers.Authorization = `Bearer ${sessionToken}`;
    } else {
      console.warn('No session token found in localStorage - request may fail with 401');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('Unauthorized (401) - API request failed');
      
      // Check if user has session_token
      const guestUser = localStorage.getItem('guestUser');
      const user = localStorage.getItem('user');
      
      let hasToken = false;
      if (guestUser) {
        try {
          const parsed = JSON.parse(guestUser);
          hasToken = !!parsed.session_token;
        } catch (e) {}
      }
      if (!hasToken && user) {
        try {
          const parsed = JSON.parse(user);
          hasToken = !!parsed.session_token;
        } catch (e) {}
      }
      
      // If user exists but no token, they have an old session - force re-login
      if (!hasToken && (guestUser || user)) {
        console.log('No session token found - clearing old session and redirecting to login');
        localStorage.removeItem('user');
        localStorage.removeItem('guestUser');
        
        // Only redirect if not already on landing page
        if (window.location.pathname !== '/') {
          window.location.href = '/';
        }
      } else if (hasToken) {
        // Has token but still got 401 - token might be expired
        console.log('Token exists but expired - clearing session');
        localStorage.removeItem('user');
        localStorage.removeItem('guestUser');
        
        if (window.location.pathname !== '/') {
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
